import { ToastContainer, toast } from "react-toastify";
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PageLoader from "./components/PageLoader";
const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const FarmerManagement = lazy(() => import("./pages/FarmerManagement"));
const Reports = lazy(() => import("./pages/Reports"));
const Forbidden = lazy(() => import("./components/Forbidden"));
const PageNotFound = lazy(() => import("./pages/PageNotFound.js"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const Layout = lazy(() => import("./components/Layout"));
const Productslist = lazy(() => import("./pages/Productslist"));
const Addproduct = lazy(() => import("./pages/Addproduct"));
const StockManagement = lazy(() => import("./pages/StockManagement"));
const StatesList = lazy(() => import("./pages/regions/Stateslist"));
const DistrictsList = lazy(() => import("./pages/regions/DIstrictsList"));
const VillagesList = lazy(() => import("./pages/regions/VillagesList"));
const AddState = lazy(() => import("./pages/regions/AddState"));
const AddDistrict = lazy(() => import("./pages/regions/AddDistrict"));
const AddVillageForm = lazy(() => import("./pages/regions/AddVillageForm"));
const CategorysList = lazy(() => import("./pages/CategorysList"));
const AddCategory = lazy(() => import("./pages/AddCategory"));
const AssignmentForm = lazy(() => import("./pages/AssignmentForm"));
const UsersList = lazy(() => import("./pages/userManagement/UsersList"));
const AddUser = lazy(() => import("./pages/userManagement/AddUser"));
const RolesList = lazy(() => import("./pages/userManagement/RolesList"));
const AddRole = lazy(() => import("./pages/userManagement/AddRole"));
const AddFarmer = lazy(() => import("./pages/AddFarmer"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const OtpVerification = lazy(() => import("./pages/OtpVerification"));
const PasswordReset = lazy(() => import("./pages/PasswordReset"));
const AreaList = lazy(() => import("./pages/regions/AreaList"));
const AddArea = lazy(() => import("./pages/regions/AddArea"));
const CfsList = lazy(() => import("./pages/CfsList"));
const AddCf = lazy(() => import("./pages/AddCf"));
const FormsList = lazy(() => import("./pages/FormsList"));
const CfsAssignList = lazy(() => import("./pages/CfsAssignList"));
const ReverseStockManagement = lazy(() =>
  import("./pages/ReverseStockManagement")
);
const ReverseAssignmentForm = lazy(() =>
  import("./pages/ReverseAssignmentForm")
);
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const SkusList = lazy(() => import("./pages/SkusList"));
const AddSku = lazy(() => import("./pages/AddSku"));

const App = () => {
  return (
    <>
      <ToastContainer
        autoClose={3000}
        hideProgressBar={false}
        position="top-right"
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <AuthProvider>
        {/* <Router> */}
        <Suspense
          fallback={
            <div className="flex justify-center items-center h-screen w-full">
              <PageLoader />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/otp-verify" element={<OtpVerification />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute module="Dashboard" action="read">
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/products-list"
              element={
                <ProtectedRoute module="Products" action="read">
                  <Layout>
                    <Productslist />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/farmer-management"
              element={
                <ProtectedRoute module="Farmer Management" action="read">
                  <Layout>
                    <FarmerManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute module="Reports" action="read">
                  <Layout>
                    <Reports />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/skus-list"
              element={
                <ProtectedRoute module="Skus" action="read">
                  <Layout>
                    <SkusList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-product"
              element={
                <ProtectedRoute module="Products" action="write">
                  <Layout>
                    <Addproduct />
                  </Layout>
                </ProtectedRoute>
              }
            />
                <Route
              path="/add-sku"
              element={
                <ProtectedRoute module="Skus" action="write">
                  <Layout>
                    <AddSku />
                  </Layout>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/stock-management"
              element={
                <ProtectedRoute module="Stock Management" action="read">
                  <Layout>
                    <StockManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reverse-stock-management"
              element={
                <ProtectedRoute module="Reverse Stock Management" action="read">
                  <Layout>
                    <ReverseStockManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/states"
              element={
                <ProtectedRoute module="States" action="read">
                  <Layout>
                    <StatesList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/districts"
              element={
                <ProtectedRoute module="Districts" action="read">
                  <Layout>
                    <DistrictsList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/areas"
              element={
                <ProtectedRoute module="Areas" action="read">
                  <Layout>
                    <AreaList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/villages"
              element={
                <ProtectedRoute module="Villages" action="read">
                  <Layout>
                    <VillagesList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-state"
              element={
                <ProtectedRoute module="States" action="write">
                  <Layout>
                    <AddState />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-district"
              element={
                <ProtectedRoute module="Districts" action="write">
                  <Layout>
                    <AddDistrict />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-area"
              element={
                <ProtectedRoute module="Areas" action="write">
                  <Layout>
                    <AddArea />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-village"
              element={
                <ProtectedRoute module="Villages" action="write">
                  <Layout>
                    <AddVillageForm />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/categorys"
              element={
                <ProtectedRoute module="Categories" action="read">
                  <Layout>
                    <CategorysList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-category"
              element={
                <ProtectedRoute module="Categories" action="write">
                  <Layout>
                    <AddCategory />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/assign-products"
              element={
                <ProtectedRoute module="Stock Management" action="write">
                  <Layout>
                    <AssignmentForm />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reverse-assign-products"
              element={
                <ProtectedRoute module="Reverse Stock Management" action="write">
                  <Layout>
                    <ReverseAssignmentForm />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute module="Users" action="read">
                  <Layout>
                    <UsersList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/forms-list"
              element={
                <ProtectedRoute module="Forms" action="read">
                  <Layout>
                    <FormsList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cfs-assign"
              element={
                <ProtectedRoute module="CFS Assignment" action="read">
                  <Layout>
                    <CfsAssignList />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/cfs"
              element={
                <ProtectedRoute module="Community Facilitator" action="read">
                  <Layout>
                    <CfsList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-cf"
              element={
                <ProtectedRoute module="Community Facilitator" action="write">
                  <Layout>
                    <AddCf />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute module="Users" action="write">
                  <Layout>
                    <AddUser />
                  </Layout>
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/terms-conditions"
              element={
                <ProtectedRoute action="write">
                  <Layout>
                    <TermsAndConditions />
                  </Layout>
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/roles"
              element={
                <ProtectedRoute module="Roles" action="read">
                  <Layout>
                    <RolesList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-role"
              element={
                <ProtectedRoute module="Roles" action="write">
                  <Layout>
                    <AddRole />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-farmer"
              element={
                <ProtectedRoute module="Farmer Management" action="write">
                  <Layout>
                    <AddFarmer />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
        {/* </Router> */}
      </AuthProvider>
    </>
  );
};

export default App;
